module.exports = __webpack_public_path__ + "static/img/8.e335ad12.jpg";